import { IconSvgProps } from '../types';

export const DiagramNetwork = ({ size }: IconSvgProps) => (
  <svg
    id="icon-content-diagram network"
    width={size}
    height={size}
    viewBox="0 0 61 65"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="currentColor" fillRule="nonzero">
        <g>
          <path
            d="M41.96,8.78 C42.66,7.66 44.14,7.31 45.26,8.01 C46.36,8.69 46.72,10.1 46.1,11.21 L46.04,11.31 L29.51,37.98 C28.81,39.11 27.33,39.45 26.2,38.76 C25.11,38.08 24.75,36.67 25.37,35.55 L25.43,35.45 L41.96,8.78 Z"
            opacity="0.5"
          />
          <path
            d="M4.46,13.67 C5.38,12.77 6.83,12.76 7.76,13.62 L7.85,13.71 L29.18,35.58 C30.11,36.52 30.09,38.04 29.14,38.97 C28.22,39.87 26.77,39.88 25.84,39.01 L25.75,38.93 L4.42,17.06 C3.49,16.11 3.51,14.59 4.46,13.67 Z"
            opacity="0.5"
          />
          <path
            d="M25.77,35.02 C26.71,34.08 28.23,34.08 29.16,35.02 C30.07,35.93 30.1,37.38 29.25,38.32 L29.16,38.41 L7.83,59.75 C6.89,60.68 5.37,60.68 4.44,59.75 C3.53,58.84 3.5,57.38 4.35,56.44 L4.44,56.35 L25.77,35.02 Z"
            opacity="0.5"
          />
          <path
            d="M24.97,35.83 C25.44,34.64 26.77,34.03 27.98,34.45 L28.08,34.49 L55.02,45.15 C56.25,45.64 56.85,47.04 56.37,48.27 C55.89,49.46 54.56,50.07 53.36,49.66 L53.25,49.62 L26.32,38.95 C25.08,38.46 24.48,37.07 24.97,35.83 Z"
            opacity="0.5"
          />
          <circle cx="27.47" cy="36.72" r="9.33333" />
          <circle cx="6.13" cy="15.38" r="6.13333" />
          <circle cx="54.13" cy="47.38" r="6.13333" />
          <circle cx="43.47" cy="9.52" r="9.33333" />
          <circle cx="6.13" cy="58.05" r="6.13333" />
        </g>
      </g>
    </g>
  </svg>
);
